import React from "react";

export default function AppLayout(): React.JSX.Element {
  return <></>;
}
